import { render, staticRenderFns } from "./CoinsOverviewGrid.vue?vue&type=template&id=3565e7da&scoped=true&"
import script from "./CoinsOverviewGrid.vue?vue&type=script&lang=ts&"
export * from "./CoinsOverviewGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CoinsOverviewGrid.vue?vue&type=style&index=0&id=3565e7da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565e7da",
  null
  
)

export default component.exports